import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import AccountLanguage from 'Components/Account/WebsiteSettings/AccountLanguage';
import AccountTheme from 'Components/Account/WebsiteSettings/AccountTheme';

function WebsiteSettings({ language }) {
  return (
    <section className="account-content">
      <h1>
        <FormattedMessage id="account-website-settings.heading" defaultMessage="Website Settings" />
      </h1>
      <div className="account-table login-and-security">
        <AccountLanguage language={language} />
        <AccountTheme />
      </div>
    </section>
  );
}

WebsiteSettings.propTypes = {
  language: PropTypes.shape({}),
};

WebsiteSettings.defaultProps = {
  language: {},
};


const mapStateToProps = ({
  auth: {
    language,
  },
}) => ({
  language,
});

export default connect(mapStateToProps)(WebsiteSettings);
